import clsx from 'clsx';
// mantine
import { MantineSize } from '@mantine/core';

interface NoRecordsProps {
    className?: string;
    children?: React.ReactNode;
    size?: MantineSize;
}

const NoRecords = ({ children, size = 'sm', className }: NoRecordsProps) => {
    return (
        <div
            className={clsx(
                'flex items-center justify-center py-16 text-gray-6',
                `text-${size}`,
                className
            )}
        >
            {children ?? 'No records found'}
        </div>
    );
};

export default NoRecords;
